import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { textWithEllipsisStyle } from 'utilities';

const StyledTitle = styled(Typography)(({ theme }) => ({
  ...textWithEllipsisStyle,
  fontWeight: 700,
  paddingRight: theme.spacing(1.5),
}));

export { StyledTitle };
